// extracted by mini-css-extract-plugin
export default {"container":"EN-z","darkBackground":"FN-z","whiteBackground":"GN-z","headerButton":"HN-z","calloutHeading":"IN-z","calloutSubHeading":"JN-z"};